import React, { useState, useRef } from "react";
import { Typography, message } from "antd";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import ReactPlayer from "react-player";
import ReactH5AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
// import { DownloadOutlined } from "@ant-design/icons";
const { Text } = Typography;

const FilePreviewerCynter = ({ fileUrl, isReadyToRender = true }) => {
  const [hasError, setHasError] = useState(false);
  const [docViewerKey] = useState(Date.now());

  const fileName = fileUrl?.split("/")?.pop() || "Unknown File";
  const fileType = fileName?.split(".")?.pop()?.toUpperCase() || "N/A";
  const audioPlayerRef = useRef(null);

  const docs = [
    {
      uri: fileUrl,
      fileType: fileType.toLowerCase(),
      fileName,
    },
  ];
  const isVideo = ["MP4", "WEBM", "OGG"].includes(fileType);

  const isAudio = ["MP3", "WAV", "M4A", "OGG", "OGA", "AAC"].includes(fileType);
  return (
    <div
      style={{
        width: "auto", // fixed preview width
        height: "auto", // fixed preview height
        border: "1px solid #ccc",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff", // make sure no black background
      }}
    >
      {!hasError && fileUrl && isReadyToRender ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden", // scroll only inside
          }}
        >
          {isVideo ? (
            <ReactPlayer src={fileUrl} controls width="100%" height="70%" />
          ) : isAudio ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "32px 16px",
                minHeight: "200px",
              }}
            >
              <ReactH5AudioPlayer
                ref={audioPlayerRef}
                src={fileUrl}
                autoPlay={false}
                onError={(e) => {
                  console.error("Audio error:", e);
                  message.error("Failed to play audio.");
                  setHasError(true);
                }}
                showJumpControls={false}
                style={{ width: "100%", maxWidth: 600 }}
              />
              <Text type="secondary" style={{ marginTop: 16 }}>
                Audio file: {fileName}
              </Text>
            </div>
          ) : (
            <DocViewer
              key={docViewerKey}
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
              onDocumentLoadFailed={() => {
                setHasError(true);
                message.error("Failed to load the document.");
              }}
            />
          )}
        </div>
      ) : (
        <Text type="secondary" style={{ padding: 16 }}>
          Loading preview...
        </Text>
      )}
    </div>
  );
};

export default FilePreviewerCynter;
